import React, { FC } from "react";
import "./layout-app.less";
import "./main.css";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "app.store";
import { Header } from "./header";
type LayoutAppProps = any;

const LayoutApp: FC<LayoutAppProps> = (props) => {
  const isLogin = useSelector(
    (state: RootState) => state.account.isAuthentication,
    shallowEqual
  );
  return  (
    <section id="cart" className="bg-third p-top-2 p-bot-4">
          <Header />
          <div className="section-body container">{props.children}</div>
        </section>
  );
};

export default LayoutApp;
